import { useGraphQLQuery } from '@betterment/graphql';

import {
  ActiveIntIraContributionsByYearDocument,
  ActiveIntIraContributionsByYearQuery,
} from './graphql/query.activeIntIraContributionsByYear.generated';

import { AccountHolderDocument } from '../graphql/query.accountHolder.generated';

type IraContributions = ActiveIntIraContributionsByYearQuery['household']['members'][0]['iraContributions'];

export interface IraContributionOnlyQueryResult {
  isLoading: boolean;
  iraContributions?: IraContributions;
  clientId?: string;
}

export const useActiveIraContributionsByYearQuery = (
  householdId: string,
  accountId: string
): IraContributionOnlyQueryResult => {
  const { data: contributionData, loading: isLoadingContributionData } = useGraphQLQuery(
    ActiveIntIraContributionsByYearDocument,
    {
      variables: { id: householdId },
      throwOnError: true,
    }
  );
  const { data: accountData, loading: isLoadingAccountData } = useGraphQLQuery(AccountHolderDocument, {
    variables: { id: accountId },
    throwOnError: true,
  });

  const filteredContributionData = contributionData?.household?.members?.find(member =>
    accountData?.envelopeAccount?.accountHolders?.some(holder => holder.id === member.id)
  );

  const isLoading = isLoadingContributionData || isLoadingAccountData;

  return {
    isLoading,
    iraContributions: filteredContributionData?.iraContributions,
    clientId: filteredContributionData?.id,
  };
};
